import Filters from './FiltersPage';

export default Filters;
